<div class="card">
    <div class="flex items-center font-semibold text-2xl mb-4">{{ user.nome }} {{ user.cognome }}

        <ng-container *ngFor="let role of user.authorities">
            <p-badge *ngIf="role === 'ROLE_ADMIN'" [value]="getRoleName(role)" severity="success" [ngStyle]="{ 'margin-right': '1rem', 'margin-left': '1rem' }">
            </p-badge>
            <p-badge *ngIf="role === 'ROLE_USER'" [value]="getRoleName(role)" severity="warn">
            </p-badge>
        </ng-container>
    </div>

    <div class="flex flex-col gap-8 mt-2">

        <!-- PRIMA RIGA -->
        <div class="flex flex-col lg:flex-row items-stretch gap-8">
            <div class="card w-full lg:w-1/2 h-full" style="margin-right: 2rem;">
                <div class="font-semibold text-2xl mb-4">Informazioni Personali</div>
                <div class="mb-4"><span class="font-semibold text-gray-500">Nome:</span> {{ user.nome }}</div>
                <div class="mb-4"><span class="font-semibold text-gray-500">Cognome:</span> {{ user.cognome }}</div>
                <div class="mb-4"><span class="font-semibold text-gray-500">Email:</span> {{ user.uid }}</div>
            </div>

            <div class="card w-full lg:w-1/2 h-full">
                <div class="font-semibold text-2xl mb-4">Dettagli Account</div>
                <div class="mb-4"><span class="font-semibold text-gray-500">Tipo Utente:</span> {{ user.tipoUtente }}
                </div>
                <div class="mb-4"><span class="font-semibold text-gray-500">Telefono:</span> {{ user.telefono || '-' }}
                </div>
                <div class="mb-4"><span class="font-semibold text-gray-500">Dipendenti:</span> {{
                    user?.dipendenti?.length || 0 }}</div>
            </div>
        </div>





    </div>
</div>